<template>
  <div class="privatstep2">
    <select-tarif v-if="selectTarifAllowed"
                    :state-path="statePath" />
    <v-row no-gutters
           align="end"
           class="main--section">
      <v-col cols="2"
             class="ueber primary--text"
      >Produkte
      </v-col>
      <v-col cols="4"><span v-if="producterror"
                        class="error--text errormessage">Bitte wählen Sie ein Produkt aus.</span></v-col>
      <v-spacer />
      <router-link :to="productInfoLink"
                   target="_blank">
        <v-btn color="primary"
               class="standard-button">Produktvergleich
        </v-btn>
      </router-link>
    </v-row>

    <price-matrix :state-path="statePath"
                  @producterror="$emit('producterror')"
                  @info="showInfoMessage" />

    <v-row v-if="$store.getters.needsProfessionalDriversWarning(statePath)"
              class="warning--text errormessage mt-6 flex-nowrap"
              align="center"
              no-gutters>
      <v-icon color="warning"
              size="28"
              class="pa-2">info
      </v-icon>
      <div>Für Berufskraftfahrer nur ab Selbstbeteiligung 300,- € möglich.
        <template v-if="!aenderung">Die Angabe des Berufs erfolgt im nächsten Schritt unter
          <span style="white-space: nowrap">"Persönliche Daten".</span>
        </template>
      </div>
    </v-row>



    <div v-if="productLine=='YOLIG'" id="yoligcheckboxes">
      <div class="primary--text semanticsection-title3">
        <span class="ueber">Für YOLIG relevant </span>
        <site-tooltip class="ml-4"
         content-class="dmbwidetooltip">
          <template v-slot:default>
          Günstig für den Beitrag von YOLIG:<br>
          <ul>
            <li>Mindestens ein zugelassenes Fahrzeug mit Elektro- oder alternativem Antrieb – Nachlass im Verkehrs-Rechtsschutz</li>
            <li>In Berufsausbildung/Studium – Nachlass im Berufs- und/oder Wohnungs-Rechtsschutz für max. 4 Jahre</li>
            <li>Ruhestands-Berufs-Rechtsschutz – Nachlass im Berufs-Rechtsschutz</li>
          </ul>
          </template>
        </site-tooltip>
      </div>
      <v-container fluid class="pa-0">
        <v-row v-if="categories.indexOf('V') >= 0" no-gutters class="flex-nowrap yoligoptions">
          <v-checkbox
            v-model="yoligekfz"
            color="primary"
            hide-details
            class="pa-0 no-max-width"
          >
            <template slot="label">
              <span class="yoliglable">
                Auf den Versicherungsnehmer oder die mitversicherten Personen
                ist mindestens ein Fahrzeug mit Elektro- oder alternativem Antrieb ( 100 % Strombetrieb oder alternativer Antrieb, kein Hybrid- oder Verbrennungsmotor)
                zugelassen
              </span>
            </template>
          </v-checkbox>
        </v-row>
        <v-row v-if="categories.indexOf('B') >= 0 || categories.indexOf('W') >= 0" no-gutters class="flex-nowrap yoligoptions">
          <v-checkbox
            v-model="yoligazubi"
            color="primary"
            hide-details
            class="pa-0 no-max-width"
            @change="azubiChanged"
          >
            <template slot="label">
              <span class="yoliglablewide">
                Der Versicherungsnehmer befindet sich in Berufsausbildung oder
                im Studium

                <site-tooltip>
                 Beitragsreduzierung für den Berufs- sowie Wohnungs- und Grundstücks-Rechtsschutz für VN, die sich in Berufsausbildung
                 oder Studium befinden. Nachlass ist zeitlich auf 4 Jahre begrenzt und entfällt nach Ablauf der Berufsausbildung/Studium
                 automatisch. VN ist verpflichtet, der DMB Rechtsschutz mitzuteilen, wenn die Berufsausbildung oder das Studium
                 vor Ablauf der 4 Jahre beendet ist. Dann entfällt die Beitragsreduzierung. 
                </site-tooltip></span
              >
            </template>
          </v-checkbox>
        </v-row>
        <v-row v-if="categories.indexOf('B') >= 0" no-gutters class="flex-nowrap yoligoptions">
          <v-checkbox
            v-model="yoligrentner"
            color="primary"
            hide-details
            class="pa-0 no-max-width"
            @change="rentnerChanged"
          >
            <template slot="label">
              <span class="yoliglable">
                Der Versicherungsnehmer oder die mitversicherte Person befindet
                sich im Ruhestand und der Ausschluss des Arbeits-Rechtsschutzes
                wird gewünscht

                <site-tooltip>
                  Ruhestands-Berufs-Rechtsschutz: Arbeits-Rechtsschutz für den VN und die mitversicherte Person 
                  besteht für die berufliche Tätigkeit, die ausschließlich der Ergänzung
                  von Ruhestandsbezügen dient (z.B. Minijobs), für dienst- und versorgungsrechtliche Ansprüche aus der vor dem Ruhestand
                  ausgeübten Tätigkeit, als Arbeitgeber hauswirtschaftlicher Beschäftigungsverhältnisse (z.B. Haushaltshilfe, Pflegekraft)
                </site-tooltip></span
              >
            </template>
          </v-checkbox>
        </v-row>
      </v-container>
    </div>





    <div class="semanticsection-title2">
      <span class="primary--text ueber mr-1">Zusatzbausteine</span>
      <site-tooltip class="ml-4">
        Sobald ein Produkt (mindestens EXPERT) ausgewählt ist, werden Zusatzbausteine angeboten (bei Auswahl von mindestens zwei Lebensbereichen, z. B. Privat und Verkehr).
      </site-tooltip>
    </div>

    <template v-if=" !(cyberdisabled && ssrdisabled && zwdisabled && vermdisabled)">

      <v-row class="mylabels" no-gutters>
        <v-spacer />

        <v-col cols="3"
                class="zusatz--column">
          <span>Selbstbeteiligung</span>
        </v-col>

        <v-col cols="3"
                class="zusatz--column">
          <span>Beitrag</span>
        </v-col>
      </v-row>

      <hr class="v-divider first">

      <zusatz-cyber v-if="!cyberdisabled"
                    :state-path="statePath" />

      <hr v-if="!cyberdisabled"
          class="v-divider">

      <zusatz-ssr v-if="!ssrdisabled"
                  :state-path="statePath" />

      <hr v-if="!ssrdisabled"
          class="v-divider">

      <zusatz-zweitwohnung v-if="!zwdisabled"
                           :state-path="statePath" />

      <hr v-if="!zwdisabled"
          class="v-divider">

      <zusatz-vermieter v-if="!vermdisabled"
                        :state-path="statePath" />

      <hr v-if="!vermdisabled"
          class="v-divider">

    </template>

    <rabattvollmacht v-if="!aenderung && (rabattAllowed || useOeko || couponAvailable) && !sus"
                     :state-path="statePath"
                     :oeko="useOeko" />

    <v-row no-gutters class="stepperbuttons">
      <v-btn color="primary"
             class="standard-button"
             @click="$emit('step-back')">Zurück
      </v-btn>
      <v-spacer />
      <v-btn color="primary"
             class="standard-button"
             @click="$emit('step-forward')">Weiter
      </v-btn>
    </v-row>

    <v-snackbar v-model="displayInfoMessage"
                :timeout="4000"
                color="primary"
                bottom
                multi-line>
        <span class="text-center info--message">
          <v-icon color="white">info</v-icon>&nbsp;{{ infoMessageText }}</span>
    </v-snackbar>

  </div>
</template>
<script>
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import PriceMatrix from "@/components/privatkundenrechner/PriceMatrix";
import ZusatzSsr from "@/components/privatkundenrechner/ZusatzSSR";
import ZusatzZweitwohnung from "@/components/privatkundenrechner/ZusatzZweitwohnung";
import ZusatzCyber from "@/components/privatkundenrechner/ZusatzCyber";
import ZusatzVermieter from "@/components/privatkundenrechner/ZusatzVermieter";
import Rabattvollmacht from "@/components/privatkundenrechner/Rabattvollmacht";
import {RIGHTS} from "@/store/user";
import SelectTarif from "@/components/privatkundenrechner/SelectTarif";

export default {
  components: {
    PriceMatrix,
    ZusatzSsr,
    ZusatzCyber,
    ZusatzZweitwohnung,
    ZusatzVermieter,
    Rabattvollmacht,
    SelectTarif
  },
  mixins: [twowayBinding],
  props: {
    producterror: {
      type: Boolean,
      required: true
    },
    aenderung: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayInfoMessage: false,
      infoMessageText: ''
    };
  },
  computed: {
    ...mapTwoWay([
      "rabattProzent",
      "coupon",
      "categories",
      "productLine",
      "sus",
      "ssr",
      "cyberdisabled",
      "ssrdisabled",
      "zwdisabled",
      "vermdisabled",
      "yoligekfz",
      "yoligazubi",
      "yoligrentner"]),
    selectTarifAllowed() {
      return this.$store.getters.checkAuthorization(RIGHTS.TARIFSELECTION);
    },
    lessThenExpert: function () {
      if (!this.productLine) {
        return true;
      } else return !(this.productLine === "EXP" || this.productLine === "PRE");
    },
    rabattAllowed() {
      return this.$store.getters.rabattVollmacht;
    },
    couponAvailable() {
      const coupon = this.coupon ?? "";
      return coupon.length > 0 && this.rabattProzent > 0;
    },
    useOeko() {
      return this.$store.getters.checkAuthorization(RIGHTS.OEKO);
    },
    productInfoLink() {
      if (this.productLine == 'YOLIG') {
        return "produkte/privatkunden/yolig";
      } else if ( this.$store.getters.productKey(this.statePath) === 'S&S PBVW+SSR' ) {
        return "produkte/privatkunden/sus";
      } else {
        return "produkte/privatkunden";
      }
    }
  },
  methods: {
    azubiChanged() {
      if (this.yoligrentner && this.yoligazubi) this.yoligrentner = false;
    },
    rentnerChanged() {
      if (this.yoligrentner && this.yoligazubi) this.yoligazubi = false;
    },
    showInfoMessage: function (ev) {
      this.infoMessageText = ev.msg;
      this.displayInfoMessage = true;
    }
  }
};
</script>
<style>
.step2--header {
  font-size: 24px;
  font-weight: 300;
}

.privatstep2 .errormessage {
  font-size: 16px;
}
.privatstep2 .yoligoptions {
  padding-top: 24px;
}

.privatstep2 .yoliglable {
  width: 65%;
}
.privatstep2 .yoliglablewide {
  width: 100%;
}
.privatstep2 .main--section {
  margin-bottom: 40px !important;
}

.privatstep2 .main--section:not(:first-child) {
  margin-top: 56px !important;
}

.privatstep2 .layout--center {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
}

.privatstep2 .v-divider {
  color: rgba(0, 0, 0, .12);
  margin: 38px 0 40px 0;
}

.privatstep2 .v-divider.first {
  margin-top: 16px !important;
}

.privatstep2 .mylabels {
  font-size: 16px;
}

.privatstep2 .zusatz--column {
  text-align: right;
  padding-right: 48px !important;
}

.privatstep2 .semanticsection-title2 {
  display: flex;
  align-items: center;
}

.info--message {
  font-size: 16px !important;
}

.privatstep2 .v-input {
  margin-bottom: 0 !important;
}
</style>
